import api from "./api";

/**
 * Phase 15 — global search fetcher. Owner/ops only on the backend.
 * Returns:
 *   { customers, properties, work_orders, service_requests, rma_records }
 * each is an array of { id, label, sublabel }.
 */
export async function fetchGlobalSearch(q) {
  if (!q || q.trim().length < 2) {
    return {
      customers: [],
      properties: [],
      work_orders: [],
      service_requests: [],
      rma_records: [],
    };
  }
  const { data } = await api.get("/search", { params: { q: q.trim() } });
  return data;
}

/** Total result count across every category. */
export function countResults(results) {
  if (!results) return 0;
  return (
    (results.customers?.length || 0) +
    (results.properties?.length || 0) +
    (results.work_orders?.length || 0) +
    (results.service_requests?.length || 0) +
    (results.rma_records?.length || 0)
  );
}

/** Path each category's result row navigates to. */
export function pathFor(category, id) {
  switch (category) {
    case "customers":
      return `/customers/${id}`;
    case "properties":
      return `/properties/${id}`;
    case "work_orders":
      return `/work-orders/${id}`;
    case "service_requests":
      return `/service-requests/${id}`;
    case "rma_records":
      return `/rma-records/${id}`;
    default:
      return "/";
  }
}

export const CATEGORY_LABELS = {
  customers: "Customers",
  properties: "Properties",
  work_orders: "Work Orders",
  service_requests: "Service Requests",
  rma_records: "RMA Claims",
};

/** Display order of categories in the dropdown / palette. */
export const CATEGORY_ORDER = [
  "customers",
  "properties",
  "work_orders",
  "service_requests",
  "rma_records",
];
